<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 15.3333V20.3333C3 20.7015 3.29848 21 3.66667 21H20.3333C20.7015 21 21 20.7015 21 20.3333V3.69231C21 3.30996 20.69 3 20.3077 3H15.0769C14.5246 3 14.0769 3.44772 14.0769 4V8.30769C14.0769 8.69004 13.767 9 13.3846 9H9.53846C8.98618 9 8.53846 9.44772 8.53846 10V13.3333C8.53846 13.8856 8.09075 14.3333 7.53846 14.3333H4C3.44772 14.3333 3 14.781 3 15.3333Z"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>
<style scoped>
svg {
  color: #1a1a1a;
}
</style>
